var _rect, _rect2, _path, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.4316,
    y: 48.1172,
    width: 11.3849,
    height: 70.0612,
    rx: 5.69247,
    transform: "rotate(22.2698 82.4316 48.1172)",
    fill: "#57818A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3379,
    y: 49.6621,
    width: 18.3911,
    height: 28.9002,
    rx: 7,
    transform: "rotate(-67.7302 72.3379 49.6621)",
    fill: "#569DA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5597 44.0193C64.5202 29.4642 78.9131 31.9087 84.9547 35.0267L81.9341 40.554C73.4911 38.0621 62.8981 41.1282 58.5597 44.0193Z",
    fill: "#569DA5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.34,
    y: 45.0684,
    width: 11.3849,
    height: 17.5153,
    rx: 4,
    transform: "rotate(22.2698 107.34 45.0684)",
    fill: "#569DA5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 104.059,
    y: 48.457,
    width: 3.50306,
    height: 7.00612,
    transform: "rotate(22.2698 104.059 48.457)",
    fill: "#759EA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClo2);
export default __webpack_public_path__ + "static/media/clo-2.fe2594c6ce2f5e6d50df762d89bcf92a.svg";
export { ForwardRef as ReactComponent };